import CategoryBadge from './CategoryBadge'

export default CategoryBadge
